import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    bottom: theme.spacing(1),
  },
});

const AppVersionWatermark = ({ classes }) => (
  <div className={classes.root}>
    <Typography
      color="secondary"
      variant="caption">
      {process.env.REACT_APP_VERSION}
    </Typography>
  </div>
);

export default withStyles(styles)(AppVersionWatermark);
